import styled from 'styled-components';

export const AccessibilityStatementWrapperStyled = styled.div`
  display: grid;
`;

export const AccessibilityStatementButtonStyled = styled.button`
  color: ${({ theme }) => theme.colors.stageText || theme.baseColors.white};
  padding: 0;
  min-height: 1.3rem;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  font-size: ${({ theme }) => theme.fontSizes.medium};
  cursor: pointer;
  font-family: ${({ theme }) => `'${theme.fontFamily.join("', '")}'`};
  letter-spacing: 0.005em;
  background-color: transparent;
  border: none;
  margin: 1rem 0;

  &:hover {
    text-decoration: underline;
  }
`;
